import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

export default class Step extends React.Component {
  render() {
    const { link, title, active, done, disabled } = this.props;

    return (
      <li className={classnames('step', { active, done, disabled })}>
      {
        disabled
        ? <span className="step-name disabled">{title}</span>
        : <Link to={link} className="step-name">{title}</Link>
      }
      </li>
    );
  }
}
